export const uuidTacx = {
    service: "6e40fec1-b5a3-f393-e0a9-e50e24dcca9e",
    readCharacteristic: "6e40fec2-b5a3-f393-e0a9-e50e24dcca9e",
    writeCharacteristic: "6e40fec3-b5a3-f393-e0a9-e50e24dcca9e",
};
